/*css*/
import './App.css';

/*React*/
import { lazy } from 'react';
import {BrowserRouter,Routes,Route} from "react-router-dom";
import { Suspense } from 'react';

/*pages*/
const Index = lazy(() => import("./pages/index"));
const FAQ = lazy(() => import("./pages/FAQ"));
const ContactPage = lazy(() => import("./pages/Contact"));
const About = lazy(() => import("./pages/About"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Privacity_Policy = lazy(() => import("./pages/Privacity_Policy"));
//404
const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  return (
      <BrowserRouter>
        <Suspense fallback={<p>Cargando...</p>}>
          <Routes>
            <Route path="/">
                <Route index element={<Index />} />
                <Route path="FAQ"  element={<FAQ />} />
                <Route path="Contact" element={<ContactPage />}/>
                <Route path="About" element={<About />}/>
                <Route path="Gallery" element={<Gallery />}/>
                <Route path="privacy-policy" element={<Privacity_Policy />}/>
                {/* 404 */}
                <Route path="*" element={<NotFound />}/>
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
  );
}

export default App;
